import I18n from 'lib/i18n'
import React from 'react'

import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import railsContext from 'lib/selectors/rails-context'

const Translate = ({ review, translateReview, translating }) => {
  const { i18nLocale } = useSelector(railsContext)
  const { id, locale, defaultLocale } = review

  const handleTranslate = reviewId => {
    translateReview(reviewId, locale === i18nLocale ? defaultLocale : i18nLocale)
  }

  if (defaultLocale === i18nLocale) {
    return null
  }

  return (
    <div>
      <span
        className='translate translatebutton'
        onClick={() => handleTranslate(id)}
        style={{ cursor: translating ? 'wait' : 'pointer' }}
      >
        {i18nLocale === locale
          ? I18n.t('jstemplates.searchresult.translated')
          : I18n.t('jstemplates.searchresult.translate')}
      </span>
    </div>
  )
}

export default Translate

Translate.propTypes = {
  review: PropTypes.object,
  translateReview: PropTypes.func,
  translating: PropTypes.bool
}
